import { http } from './http'
import { Pagination, PaginationParams } from './map'
import { Article, ArticlePayload } from '../../common/models'

export const createArticle = (data: ArticlePayload) =>
  http.post<Article>(`/operations/articles`, data)

export const getArticles = (params?: PaginationParams) =>
  http.get<Pagination<Article>>('/operations/articles', {
    params,
  })

export const getArticle = (id: string) =>
  http.get<Article>(`/operations/articles/${id}`)

export const deleteArticles = (ids: string[]) =>
  http.delete('/operations/articles', {
    data: {
      ids,
    },
  })

export const publishArticle = (ids: string[]) =>
  http.put<Article[]>('/operations/articles/publish', { ids })

export const unpublishArticle = (ids: string[]) =>
  http.put<Article[]>('/operations/articles/unpublish', { ids })

export const updateArticle = (id: string, data: ArticlePayload) =>
  http.put<Article>(`/operations/articles/${id}`, data)
